import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@blaze-cms/image-cdn-react';
import Head from 'next/head';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import { IN_VIEW_CONFIG } from '../../constants';

const LazyImage = ({ src, alt, sizeKey, priority, ...props }) => {
  const [isIntersecting, outerRef] = useInView(IN_VIEW_CONFIG);
  const shouldRender = priority || isIntersecting;
  const HeadComponent = priority ? Head : null;

  return (
    <span ref={outerRef}>
      {shouldRender && (
        <ResponsiveImage
          src={src}
          alt={alt}
          sizeKey={sizeKey}
          HeadComponent={HeadComponent}
          {...props}
        />
      )}
    </span>
  );
};

LazyImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  sizeKey: PropTypes.string.isRequired,
  priority: PropTypes.bool
};

LazyImage.defaultProps = {
  alt: '',
  priority: false
};

export default LazyImage;
